//@ts-ignore
import("./bootstrap")
